<script setup></script>

<template>
  <div class="fixed left-0 right-0 top-0 bottom-0 bg-black/[.8]" />
</template>
